// @ts-nocheck
import type { Question } from '../types';

export const vehicleCategoriesQuestions: Question[] = [
  {
    id: 'q-vc-1',
    topic: 'General',
    question: 'What is the speed limit for motorcycles on motorways in the Netherlands?',
    options: [
      { id: 'q-vc-1o1', text: '100 km/h' },
      { id: 'q-vc-1o2', text: '120 km/h' },
      { id: 'q-vc-1o3', text: '130 km/h' },
      { id: 'q-vc-1o4', text: '140 km/h' }
    ],
    answerId: 'q-vc-1o1',
    explanation: 'Motorcycles have the same speed limit as cars on motorways in the Netherlands, which is 100 km/h during good weather conditions (reduced from 130 km/h in 2020).',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-2',
    topic: 'General',
    question: 'What is the speed limit for trucks on motorways in the Netherlands?',
    options: [
      { id: 'q-vc-2o1', text: '80 km/h' },
      { id: 'q-vc-2o2', text: '90 km/h' },
      { id: 'q-vc-2o3', text: '100 km/h' },
      { id: 'q-vc-2o4', text: '110 km/h' }
    ],
    answerId: 'q-vc-2o1',
    explanation: 'Trucks have a speed limit of 80 km/h on motorways in the Netherlands, regardless of the weather conditions.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-3',
    topic: 'General',
    question: 'What is the speed limit for buses on motorways in the Netherlands?',
    options: [
      { id: 'q-vc-3o1', text: '80 km/h' },
      { id: 'q-vc-3o2', text: '90 km/h' },
      { id: 'q-vc-3o3', text: '100 km/h' },
      { id: 'q-vc-3o4', text: '110 km/h' }
    ],
    answerId: 'q-vc-3o1',
    explanation: 'Buses have a speed limit of 80 km/h on motorways in the Netherlands, the same as trucks.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-4',
    topic: 'General',
    question: 'What is the speed limit for mopeds on roads in the Netherlands?',
    options: [
      { id: 'q-vc-4o1', text: '25 km/h' },
      { id: 'q-vc-4o2', text: '30 km/h' },
      { id: 'q-vc-4o3', text: '45 km/h' },
      { id: 'q-vc-4o4', text: '50 km/h' }
    ],
    answerId: 'q-vc-4o3',
    explanation: 'Mopeds have a speed limit of 45 km/h on roads in the Netherlands, unless otherwise indicated by traffic signs.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-5',
    topic: 'General',
    question: 'What is the speed limit for tractors on roads in the Netherlands?',
    options: [
      { id: 'q-vc-5o1', text: '15 km/h' },
      { id: 'q-vc-5o2', text: '25 km/h' },
      { id: 'q-vc-5o3', text: '30 km/h' },
      { id: 'q-vc-5o4', text: '40 km/h' }
    ],
    answerId: 'q-vc-5o2',
    explanation: 'Tractors have a speed limit of 25 km/h on roads in the Netherlands, unless they have special permission for higher speeds.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-6',
    topic: 'General',
    question: 'Which lane should motorcycles use on a three-lane motorway?',
    options: [
      { id: 'q-vc-6o1', text: 'The right lane only' },
      { id: 'q-vc-6o2', text: 'The left lane only' },
      { id: 'q-vc-6o3', text: 'Any lane they choose' },
      { id: 'q-vc-6o4', text: 'The middle lane only' }
    ],
    answerId: 'q-vc-6o3',
    explanation: 'Motorcycles can use any lane on a motorway, just like cars. They should follow the same lane discipline rules.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-7',
    topic: 'General',
    question: 'Which lane should trucks use on a three-lane motorway?',
    options: [
      { id: 'q-vc-7o1', text: 'The right lane only' },
      { id: 'q-vc-7o2', text: 'The left lane only' },
      { id: 'q-vc-7o3', text: 'Any lane they choose' },
      { id: 'q-vc-7o4', text: 'The middle and right lanes' }
    ],
    answerId: 'q-vc-7o4',
    explanation: 'Trucks should use the middle and right lanes on a three-lane motorway. They are not allowed to use the left lane for overtaking.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-8',
    topic: 'General',
    question: 'What is the speed limit for cars towing trailers on motorways?',
    options: [
      { id: 'q-vc-8o1', text: '80 km/h' },
      { id: 'q-vc-8o2', text: '90 km/h' },
      { id: 'q-vc-8o3', text: '100 km/h' },
      { id: 'q-vc-8o4', text: '110 km/h' }
    ],
    answerId: 'q-vc-8o2',
    explanation: 'Cars towing trailers have a speed limit of 90 km/h on motorways in the Netherlands.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-9',
    topic: 'General',
    question: 'What is the minimum legal tread depth for car tyres in the Netherlands?',
    options: [
      { id: 'q-vc-9o1', text: '1.0 mm' },
      { id: 'q-vc-9o2', text: '1.6 mm' },
      { id: 'q-vc-9o3', text: '2.0 mm' }
    ],
    answerId: 'q-vc-9o2',
    explanation: 'The minimum legal tread depth for car tyres in the Netherlands is 1.6 mm. CBR recommends replacing tyres at 2 mm for better safety, especially in wet conditions.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-10',
    topic: 'General',
    question: 'How often should you check the brake fluid level in your vehicle?',
    options: [
      { id: 'q-vc-10o1', text: 'Only when the brake warning light comes on' },
      { id: 'q-vc-10o2', text: 'Regularly, as part of routine maintenance' },
      { id: 'q-vc-10o3', text: 'Once every 5 years' }
    ],
    answerId: 'q-vc-10o2',
    explanation: 'Brake fluid should be checked regularly as part of routine vehicle maintenance. Low brake fluid can indicate worn brake pads or a leak, both of which affect safety.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-11',
    topic: 'General',
    question: 'When should you check the engine oil level?',
    options: [
      { id: 'q-vc-11o1', text: 'When the engine is running and warm' },
      { id: 'q-vc-11o2', text: 'When the engine is cold and the car is on level ground' },
      { id: 'q-vc-11o3', text: 'Only at the annual APK inspection' }
    ],
    answerId: 'q-vc-11o2',
    explanation: 'Engine oil should be checked when the engine is cold and the vehicle is parked on level ground. This gives an accurate reading. Check regularly between services.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-12',
    topic: 'General',
    question: 'When should you replace your windscreen wipers?',
    options: [
      { id: 'q-vc-12o1', text: 'Only when they stop working completely' },
      { id: 'q-vc-12o2', text: 'When they streak, smear, or no longer clear the windscreen properly' },
      { id: 'q-vc-12o3', text: 'Every 6 months regardless of condition' }
    ],
    answerId: 'q-vc-12o2',
    explanation: 'Replace windscreen wipers when they streak, smear, or fail to clear the windscreen properly. Good visibility is essential for safe driving, especially in rain.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-13',
    topic: 'General',
    question: 'Before driving at night, what should you check regarding your vehicle lighting?',
    options: [
      { id: 'q-vc-13o1', text: 'Only the headlights' },
      { id: 'q-vc-13o2', text: 'All lights: headlights, tail lights, indicators, and brake lights' },
      { id: 'q-vc-13o3', text: 'Lights are not necessary to check; they are always working' }
    ],
    answerId: 'q-vc-13o2',
    explanation: 'Before driving at night, check that all lights work: headlights (dipped and main beam), tail lights, indicators, brake lights, and number plate light. Faulty lights are a safety risk.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-14',
    topic: 'General',
    question: 'What is the minimum age requirement to drive a category B vehicle in the Netherlands?',
    options: [
      { id: 'q-vc-14o1', text: '16 years' },
      { id: 'q-vc-14o2', text: '17 years' },
      { id: 'q-vc-14o3', text: '18 years' }
    ],
    answerId: 'q-vc-14o3',
    explanation: 'The minimum age to drive a category B vehicle (standard passenger car) in the Netherlands is 18 years. Supervised driving is allowed from age 17 under certain conditions.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-15',
    topic: 'General',
    question: 'What is the maximum permitted mass (permissible gross vehicle weight rating) you can tow with a category B license?',
    options: [
      { id: 'q-vc-15o1', text: 'Up to 750 kg without restrictions' },
      { id: 'q-vc-15o2', text: 'Only trailers with a maximum mass of 50% of the vehicle\'s mass' },
      { id: 'q-vc-15o3', text: 'No trailers allowed' }
    ],
    answerId: 'q-vc-15o1',
    explanation: 'With a category B license, you can tow a trailer with a maximum permissible gross vehicle weight rating of 750 kg without needing additional endorsements or license categories.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-16',
    topic: 'General',
    question: 'What does category C1 vehicle license allow you to drive?',
    options: [
      { id: 'q-vc-16o1', text: 'Only passenger vehicles' },
      { id: 'q-vc-16o2', text: 'Vans and light trucks up to 7,500 kg permissible gross vehicle weight rating' },
      { id: 'q-vc-16o3', text: 'Any heavy truck' }
    ],
    answerId: 'q-vc-16o2',
    explanation: 'Category C1 license allows you to drive vehicles (vans and light trucks) with a permissible gross vehicle weight rating between 3,500 kg and 7,500 kg. You must be at least 18 years old.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-17',
    topic: 'General',
    question: 'What is the minimum age to obtain a category A (motorcycle) license in the Netherlands?',
    options: [
      { id: 'q-vc-17o1', text: '16 years' },
      { id: 'q-vc-17o2', text: '18 years' },
      { id: 'q-vc-17o3', text: '20 years' }
    ],
    answerId: 'q-vc-17o2',
    explanation: 'You must be at least 18 years old to obtain a full category A motorcycle license in the Netherlands. A restricted category A license (125cc max) is available from age 16.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-18',
    topic: 'General',
    question: 'What is the definition of a category M vehicle?',
    options: [
      { id: 'q-vc-18o1', text: 'Mopeds and motorcycles with maximum 50cc engine' },
      { id: 'q-vc-18o2', text: 'Motorcycles with maximum 125cc engine' },
      { id: 'q-vc-18o3', text: 'Heavy trucks' }
    ],
    answerId: 'q-vc-18o1',
    explanation: 'Category M vehicles include mopeds and small motorcycles with engines not exceeding 50cc and a maximum design speed of 45 km/h. You can drive category M vehicles from age 16.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-19',
    topic: 'General',
    question: 'What is the difference between category B and category B+E licenses?',
    options: [
      { id: 'q-vc-19o1', text: 'B+E allows towing trailers heavier than 750 kg' },
      { id: 'q-vc-19o2', text: 'B+E allows driving vans' },
      { id: 'q-vc-19o3', text: 'There is no difference' }
    ],
    answerId: 'q-vc-19o1',
    explanation: 'Category B+E (B with trailer endorsement) allows drivers to tow trailers heavier than 750 kg and with a higher permissible gross vehicle weight rating. Category B alone limits trailer towing to 750 kg.',
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-20',
    topic: 'General',
    question: 'What vehicles can you drive with a category D license?',
    options: [
      { id: 'q-vc-20o1', text: 'Buses and coaches with more than 8 passenger seats' },
      { id: 'q-vc-20o2', text: 'Heavy trucks and tractors' },
      { id: 'q-vc-20o3', text: 'Only minibuses' }
    ],
    answerId: 'q-vc-20o1',
    explanation: 'Category D license allows you to drive buses and coaches designed to carry more than 8 passengers. You must be at least 24 years old and have held a category B license for at least 2 years.',
    subject: 'Vehicle Categories'
  }
];
